module.exports = __webpack_public_path__ + "static/media/blue-loader.91d35ebf.svg";